import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './assets/js/api'
import './assets/css/reset.css'
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(Vant)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
